export default "__VITE_ASSET__DM6VublP__"